import React from "react";
import FAQAccordion from '../FAQAccordion';

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

 render() {
  return (
    <React.Fragment>
      <section id="info-how-to-pack-hiking-backpack-diagram" className="about-us pt-trip gray-light-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div>
              <div className="section-heading mb-5 mx-2">
                {this.props.showTitle && this.props.showTitle === true && (
                  <span className="badge badge-primary badge-pill">
                    Hiking Backpack Packing
                  </span>
                )}
                <FAQAccordion
                  title="How to Pack a Hiking Backpack FAQs"
                  items={[
                    { q: 'Where should heavy items go in a hiking backpack?', a: 'Heavy items like a tent body, bear canister, and food should go closest to your back, centered between your shoulder blades and your hips. This keeps the weight close to your center of gravity and reduces strain.' },
                    { q: 'How should I organize a hiking backpack for a day hike vs. overnight?', a: 'For a day hike, keep rain gear and snacks in the top lid or brain pocket. For overnight, pack sleeping gear at the bottom, heavy items next to your back in the middle, and clothing/insulation around the sides.' },
                    { q: 'How do I prevent my pack from being too heavy?', a: 'Target 10–15% of your body weight for day hikes and 20–25% for backpacking. Weigh your pack before every trip. The three heaviest items to reduce are the shelter, sleep system, and pack itself.' },
                    { q: 'What should I keep in the top pocket of my hiking backpack?', a: 'The top pocket (brain) is for frequently accessed items: rain jacket, sunscreen, snacks, trail map, headlamp, and first aid kit. Keep it light so it does not make the pack top-heavy.' },
                    { q: 'How do I keep my hiking backpack waterproof?', a: 'Use a pack rain cover for sustained rain — most backpacks come with one in the bottom pocket. Line the inside with a trash compactor bag as a secondary layer. Pack electronics and sleeping bag in dry bags.' },
                    { q: 'Should sleeping bag go on top or bottom of backpack?', a: 'Sleeping bags go at the very bottom of the main compartment. They are light and bulky, and you will not need them until camp. This also acts as padding against your lower back.' },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}
}
export default About;